import { Component, OnInit, Injector } from '@angular/core';
import { formatNumberWithCommas } from '../../../Utils/utils';
import { InformationModalService } from '../../../Services/information-model-factory/information-model-factory';
import { UnderWrittenComponent } from '../under-written/under-written.component';
import { find, filter, isEmpty } from 'lodash';
import { LinkExpirationServie } from '../../../Services/link-expiration/link-expiration';
import { DomSanitizer } from '@angular/platform-browser';
import { EventsComponent } from '../events/events.component';
import * as bowser from 'bowser';
import { SubmissionPreloaderPopupComponent } from '../submission-preloader-popup/submission-preloader-popup.component';
import { StickyPackageService } from '../../../Services/sticky-package.service';

@Component({
	selector: 'coverage-packages',
	templateUrl: './coverage-packages.component.html',
	styleUrls: ['./coverage-packages.components.scss'],
})
export class CoveragePackagesComponents extends EventsComponent implements OnInit {
	packages: any[];
	showPackages: boolean;
	carrierPackage: any;
	selectedPackage: any;
	lastSelectedPackage: any;
	underWritten: string;
	isMobile: boolean;
	isTablet: boolean;
	quoteNumber: string;
	finishButtonToCustomizeFlag: boolean = false;
	isCovModFlagOn: boolean = false;
	isCustomizable: boolean = false;
	isEditMode: boolean;
	unDoEditClicked: boolean = false;
	squareActiveShown: boolean;
	showPackageDialog: boolean = false;
	failureMessage: string;
	isAgentFlowType: boolean;
	isSubmissionLoaderFlagOn: boolean = false;
	submissionLoaderPopup: any;
	showSubmissionLoader_Popup = false;
	submissionLoaderPopupData: any;
	isCallPAAFlagOn: boolean = false;
	shouldShowCallPaa: boolean = false;
	shouldShowCovMod: boolean = false;

	constructor(
		private injector: Injector,
		private informationModalService: InformationModalService,
		private linkExpiration: LinkExpirationServie,
		private sanitizer: DomSanitizer,
		private stickyPackageService: StickyPackageService
	) {
		super(injector);
		this.isEditMode = false;
		this.carrierInformationService.setEditMode(false);
	}

	ngOnInit() {
		this.layoutService.globalAttributes.subscribe((data) => {
			if (data) {
				this.quoteNumber = data.applicationId ? data.applicationId.value : '';
				this.finishButtonToCustomizeFlag = data['finishButtonToCustomize'];
				const carrierInfo = this.storeService.getValue('CarrierInformation', this.context);
				this.isCustomizable = carrierInfo != null ? carrierInfo.isCustomizable : this.isCustomizable;
				this.isCovModFlagOn =
					data['covModFlag'] ||
					(carrierInfo != null && carrierInfo.packageType) == 'Custom' ||
					(carrierInfo != null &&
						carrierInfo.packageCoverages &&
						carrierInfo.packageCoverages.find((p) => p.packageType == 'Custom'));
				this.isAgentFlowType = data['flowType'] == 'Agent';
				this.isSubmissionLoaderFlagOn = data['submissionLoaderFlag'];
				this.isCallPAAFlagOn = data['call-paa-message-pilot'];
				this.shouldShowCallPaa = this.shouldShowCallPAA();
			}
		});

		this.layoutService.staticLayout.subscribe((data) => {
			this.definePlatformType();
			if (data && data.data.metadata.page.stage == 'YourRates') {
				if (this.isCovModFlagOn) {
					this.control = data.data.metadata.page.controls.find((item) => item.controlName == 'CoveragePackages');
					const carrierInformation = this.storeService.getValue('CarrierInformation', this.context);
					const carrierName = carrierInformation.name;
					const carrier = this.control.options.find((o) => o.carrierName == carrierName);
					if (carrier) {
						this.submissionLoaderPopup = carrier.submissionLoaderPopup;
					}
					if (
						(carrierInformation.onlinebuy != null && carrierInformation.onlinebuy == false) ||
						(data.data.metadata.page.controls.find((c) => c.controlName == 'Comparison') &&
							data.data.metadata.page.controls
								.find((c) => c.controlName == 'Comparison')
								.attributes.options.find((o) => o.name == carrierName))
					) {
						this.shouldShowCovMod =
							(carrierInformation.onlinebuy != null && carrierInformation.onlinebuy == false) ||
							!data.data.metadata.page.controls
								.find((c) => c.controlName == 'Comparison')
								.attributes.options.find((o) => o.name == carrierName).value.onlinebuy;
					}

					this.carrierInformationService.setIsRecalculating(false);
					this.getSelection();
				}
			}
		});

		this.getSelection();
		if (this.selectedPackage) {
			this.linkExpiration.setLinkExpiration(this.selectedPackage.buyButton.attributes.ReQuotedData);
		}

		this.observablesService.insurerSelected.subscribe(() => {
			this.getSelection();
			if (this.selectedPackage) {
				this.linkExpiration.setLinkExpiration(this.selectedPackage.buyButton.attributes.ReQuotedData);
			}
		});

		this.definePlatformType();

		setTimeout(() => {
			if (this.isCovModFlagOn && this.isCustomizable && this.isMobile) {
				this.registerScrollCovModStickyEvent();
				this.squareActiveShown = this.isInViewport(document.getElementsByClassName('square active')[0] as HTMLElement);
				this.handleSticky();
			}
		}, 500);
	}

	definePlatformType() {
		const userAgent = window.navigator.userAgent.toLowerCase();
		const parser = bowser.getParser(userAgent);
		const platformType = parser.getPlatformType();

		this.isMobile = platformType === 'mobile';

		this.isTablet =
			platformType === 'tablet' ||
			/ipad/.test(userAgent) ||
			(window.innerWidth >= 600 && window.innerWidth <= 1024 && 'ontouchstart' in window);
	}

	handleSticky() {
		const isStickyShown =
			!!this.selectedPackage && this.isCovModFlagOn && this.isCustomizable && !this.squareActiveShown;
		this.stickyPackageService.setStickyPackageVisible(isStickyShown);
	}

	phoneClick() {
		if (this.control.attributes.phoneNumber) {
			window.location.href = 'tel:' + this.control.attributes.phoneNumber;
		}
	}

	changePackageClick() {
		this.showPackageDialog = true;
	}

	closePackageDialogPopOver() {
		this.showPackageDialog = false;
	}

	setActiveRightArrow(i: any) {
		if (this.packages[i + 1]) {
			const nextActicePackage = this.packages[i + 1].packageType;
			const elem = document.getElementById(nextActicePackage);
			elem.focus();
			this.setActive(nextActicePackage);
		}
	}

	setActiveLeftArrow(i: any) {
		if (this.packages[i - 1]) {
			const nextActicePackage = this.packages[i - 1].packageType;
			const elem = document.getElementById(nextActicePackage);
			elem.focus();
			this.setActive(nextActicePackage);
		}
	}

	setActive(packageType: any) {
		if (packageType == 'Custom' && this.isBlocked()) return;

		this.packages.forEach((item) => {
			item.active = item.packageType == packageType;
		});

		const lastSelectedPackagePrice = this.selectedPackage.price;
		this.selectedPackage = filter(this.packages, (item) => item.active)[0];

		console.log('this.selectedPackage', this.selectedPackage);

		if (this.isEditMode && !this.unDoEditClicked && packageType == 'Custom') {
			this.selectedPackage.price = lastSelectedPackagePrice;
		}

		this.value = this.storeService.getValue('CarrierInformation', this.context);
		this.value.packageType = this.selectedPackage.packageType;
		this.value.selectedPackagePrice = this.selectedPackage.price;
		this.value.buyButtonUrl = this.selectedPackage.buyButton.attributes.url;
		this.storeService.updateData('CarrierInformation', this.value, this.context);
		const staticLayout = this.layoutService.staticLayout.getValue();
		this.layoutService.staticLayout.next(staticLayout);
		this.observablesService.packageSelected.next(packageType);
		this.actionService.ajaxAction(this.control.ajaxInfo, 'page');
	}

	groupDigits(value) {
		if (value != undefined) {
			return formatNumberWithCommas(value);
		}
	}

	getSelection() {
		const carrierInformation = this.storeService.getValue('CarrierInformation', this.context);

		const carrierPackage = find(this.control.options, {
			carrierName: carrierInformation.name,
		});

		this.showPackages =
			carrierInformation.hasPackage &&
			carrierPackage != undefined &&
			carrierInformation.name == carrierPackage.carrierName;

		this.isCustomizable = carrierInformation.isCustomizable;

		if (this.showPackages) {
			this.packages = carrierPackage.packages;
			this.carrierPackage = carrierPackage;

			this.selectedPackage = filter(this.packages, (item) => item.active)[0];

			let customPackage = find(this.packages, (item) => item.packageType == 'Custom');
			if (customPackage) {
				this.isEditMode = customPackage.isEditMode;
				this.carrierInformationService.setEditMode(this.isEditMode);
			} else {
				this.isEditMode = false;
				this.carrierInformationService.setEditMode(this.isEditMode);
			}

			carrierInformation.packageType = this.selectedPackage.packageType;
			carrierInformation.selectedPackagePrice = this.selectedPackage.price;
			this.storeService.updateData('CarrierInformation', carrierInformation, this.context);

			setTimeout(() => {
				const elementId = 'underwritten';
				const elem: any = document.getElementById(elementId).querySelector('a.underwritten-link');
				if (elem) {
					this.Renderer.setAttribute(elem, 'tabindex', '0');

					elem.addEventListener(['click'], () => {
						var isOpen = this.informationModalService.isModelOpen();
						if (!isOpen) {
							this.informationModalService.open({
								data: {
									proglogo: this.control.attributes.proglogo,
									imageSrc: this.carrierPackage.imageSrc,
									expandedText: this.carrierPackage.expandedText,
									carrierName: this.carrierPackage.carrierName,
								},
								windowClass: '',
								componentType: UnderWrittenComponent,
							});
						}
					});
					elem.addEventListener(['keydown'], (event) => {
						if (event.key == 'Enter') {
							var isOpen = this.informationModalService.isModelOpen();
							if (!isOpen) {
								this.informationModalService.open({
									data: {
										proglogo: this.control.attributes.proglogo,
										imageSrc: this.carrierPackage.imageSrc,
										expandedText: this.carrierPackage.expandedText,
										carrierName: this.carrierPackage.carrierName,
									},
									windowClass: '',
									componentType: UnderWrittenComponent,
								});
							}
						} else {
							return false;
						}
					});
					elem.addEventListener(['touch'], () => {
						var isOpen = this.informationModalService.isModelOpen();
						if (!isOpen) {
							this.informationModalService.open({
								data: {
									proglogo: this.control.attributes.proglogo,
									imageSrc: this.carrierPackage.imageSrc,
									expandedText: this.carrierPackage.expandedText,
									carrierName: this.carrierPackage.carrierName,
								},
								windowClass: '',
								componentType: UnderWrittenComponent,
							});
						}
					});
					elem.addEventListener(['touchstart'], () => {
						var isOpen = this.informationModalService.isModelOpen();
						if (!isOpen) {
							this.informationModalService.open({
								data: {
									proglogo: this.control.attributes.proglogo,
									imageSrc: this.carrierPackage.imageSrc,
									expandedText: this.carrierPackage.expandedText,
									carrierName: this.carrierPackage.carrierName,
								},
								windowClass: '',
								componentType: UnderWrittenComponent,
							});
						}
					});
				}
			}, 0);
		}
	}

	finishAndBuyBtnClick() {
		const location = this.control.disabled ? '' : this.setHref();
		!this.control.disabled && (!this.hasUrl() || this.selectedPackage.buyButton.attributes.mixaction);
		//add gtm for finish and buy button click
		this.addGtmFinishAndBuyEvent();
		const buyButton = this.selectedPackage.buyButton;
		this.control.ajaxInfo = buyButton.ajaxInfo;
		this.showSubmissionLoaderPopup();
		this.actionService.ajaxAction(this.control.ajaxInfo, this.context);

		// FIX for safari wait until ajaxAction finished
		//this.observablesService.preBridgeCall = new Subject<any>();
		this.observablesService.preBridgeCall.subscribe(() => {
			!isEmpty(location) && window.open(location, '_self');
		});
	}

	private showSubmissionLoaderPopup() {
		if (
			this.isSubmissionLoaderFlagOn &&
			this.submissionLoaderPopup &&
			(!this.isAgentFlowType || (this.isAgentFlowType && this.selectedPackage.packageType != 'Custom'))
		) {
			this.submissionLoaderPopupData = {
				data: {
					title: this.submissionLoaderPopup.title,
					subtitle: this.submissionLoaderPopup.subtitle,
					secondSubtitle: this.submissionLoaderPopup.secondSubtitle,
					logo: this.submissionLoaderPopup.logo,
				},
			};
			this.showSubmissionLoader_Popup = true;

			const submissionLoaderElement = document.getElementById('submission-preloader-popup');
			if (submissionLoaderElement) {
				submissionLoaderElement.style.display = 'block'; // shows the loader
			}
		}
	}

	addGtmFinishAndBuyEvent() {}

	setHref() {
		return this.control.disabled
			? ''
			: !isEmpty(this.selectedPackage.buyButton.attributes.url)
			? this.selectedPackage.buyButton.attributes.url
			: '';
	}

	hasUrl() {
		return !isEmpty(this.selectedPackage.buyButton.attributes.url);
	}

	sanitize(url: string) {
		return this.sanitizer.bypassSecurityTrustUrl(url);
	}

	changEditMode() {
		if (this.isEditMode && !this.unDoEditClicked) {
			this.isEditMode = false;
			this.carrierInformationService.setEditMode(false);
			this.unDoEditClicked = true;
		} else if (this.isEditMode) {
			this.isEditMode = false;
			this.carrierInformationService.setEditMode(false);
		} else if (!this.isEditMode) {
			this.isEditMode = true;
			this.carrierInformationService.setEditMode(true);
		}

		this.sendEditAjax();
	}

	sendEditAjax() {
		var carrierInformation = this.storeService.getValue('CarrierInformation', 'page');
		var ajaxAction = this.control.attributes.editBox.ajaxInfos.find(
			(ajaxInfo) => ajaxInfo.carrierName == carrierInformation.name
		).action;

		const requestBody: request = {
			data: {
				carrierInformation: {
					carrierName: carrierInformation.name,
					lob: carrierInformation.lobname,
					packagePrice: carrierInformation.packagePrice,
					packageType: filter(this.packages, (item) => {
						return item.active;
					})[0].packageType,
				},
			},
			info: {
				action: ajaxAction,
				conditions: '',
				elementSrc: '',
				stage: '',
				notRenderPage: false,
			},
		};

		this.actionService.invokeAction(requestBody, true);
	}

	isRecalculating() {
		return this.carrierInformationService.isRecalculating;
	}

	showTimeoutError() {
		var customPackage = filter(this.packages, (item) => {
			return item.packageType == 'Custom';
		})[0];

		if (
			customPackage &&
			customPackage.packageType == 'Custom' &&
			customPackage.failureDetails &&
			!customPackage.failureDetails.blocked
		) {
			this.failureMessage = customPackage.failureDetails.message;

			return true;
		}

		return false;
	}

	isBlocked() {
		var customPackage = filter(this.packages, (item) => {
			return item.packageType == 'Custom';
		})[0];

		if (customPackage && customPackage.failureDetails && customPackage.failureDetails.blocked) {
			return true;
		}

		return false;
	}

	registerScrollCovModStickyEvent(): void {
		const debounce = (method, delay) => {
			clearTimeout(method._tId);
			method._tId = setTimeout(() => {
				method();
			}, delay);
		};

		const loop = () => {
			const squareActiveShownNewVal = this.isInViewport(
				document.getElementsByClassName('square active')[0] as HTMLElement
			);
			if (this.squareActiveShown != squareActiveShownNewVal) {
				this.squareActiveShown = squareActiveShownNewVal;
				this.handleSticky();
			}
		};
		loop.bind(this);

		const loopDebounceFunc = () => {
			debounce(() => {
				setTimeout(() => {
					loop();
				}, 1);
			}, 1000);
		};

		window.addEventListener('scroll', loopDebounceFunc, false);
	}

	isInViewport(elem: HTMLElement): boolean {
		const bouondings = elem ? elem.getBoundingClientRect() : undefined;

		if (!bouondings || (bouondings.width === 0 && bouondings.height === 0)) {
			return false;
		}

		const elemHalfLength = (bouondings.bottom - bouondings.top) / 2;

		const result =
			bouondings.bottom >= 0 &&
			bouondings.top + elemHalfLength <= (window.innerHeight || document.documentElement.clientHeight);

		return result;
	}

	isCovModCarrierSeen() {
		if (this.control.attributes.alertBox.seenCovModCarrier) return true;
		else if (this.carrierInformationService.isCovModCarrierSeen) return true;
		else return false;
	}

	shouldShowEditBox() {
		if (this.packages.length <= 3) {
			return true;
		} else {
			const customPackage = this.packages.filter((p) => p.packageType == 'Custom')[0];

			if (customPackage && customPackage.active == true) {
				return true;
			}

			return false;
		}
	}

	shouldShowCallPAA() {
		return this.isCallPAAFlagOn && this.control.attributes.callPAABox && !this.isCovModFlagOn && !this.isAgentFlowType;
	}
}
